import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { DashboardSidebar } from '@/layouts/dashboard';
import { Link } from 'react-router-dom';
import { StepperWrapper } from '@/components/custom/stepper';
import { ButtonBack, ButtonBackContent } from '@/components/ui/button';
import { IconWrapper } from '@/components/custom/icon';
import { FilterTitle } from '@/components/custom/filter';

export default function EssaySidebar(props) {
  const { steps, currentStep } = props;

  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <ButtonBack asChild>
        <Link to="/redacao">
          <IconWrapper>
            <FiChevronLeft />
          </IconWrapper>
          <ButtonBackContent>
            <FilterTitle>Redações</FilterTitle>
          </ButtonBackContent>
        </Link>
      </ButtonBack>

      <StepperWrapper
        steps={steps}
        currentStep={currentStep}
      />
    </DashboardSidebar>
  );
}
